import React from 'react';
import { Box, Typography } from '@mui/material';
import { useGetUserImportQuery } from '../../api/userImportsApi';

/** How many of a user import's rows were created, skipped and failed, as a list. */
export const UserImportCounts = ({ importId }) => {
	const { data: userImport } = useGetUserImportQuery(importId);

	return (
		<Box component='ul' sx={{ m: 0, pl: 2.5 }}>
			<Typography component='li' variant='body2'>
				{`${userImport.createdCount} created`}
			</Typography>
			<Typography component='li' variant='body2'>
				{`${userImport.skippedCount} skipped (already in Folio or repeated in the file)`}
			</Typography>
			<Typography component='li' variant='body2'>
				{`${userImport.failedCount} failed`}
			</Typography>
		</Box>
	);
};
